import { render } from "./EditZakazka.vue?vue&type=template&id=36aef20e"
import script from "./EditZakazka.vue?vue&type=script&lang=js"
export * from "./EditZakazka.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__